import React from 'react';
import PropTypes from 'prop-types';
import { ButtonToolbar } from 'reactstrap';

import EditButton from '../../../common/button/EditButton';
import { PREVENTIVE_TASK_PATH } from '../../../../config/paths';
import DeletePreventiveTaskButton from './DeletePreventiveTaskButton';
import AddResourcePreventiveTaskButton from './AddResourcePreventiveTaskButton';
import EndPreventiveTaskResourceButton from './EndPreventiveTaskResourceButton';

const PreventiveTaskToolbar = ({ preventiveTaskId, preventiveTask }) => (
  <ButtonToolbar className="pull-right">
    <div>
      <AddResourcePreventiveTaskButton preventiveTaskId={preventiveTaskId} />{' '}
      <EndPreventiveTaskResourceButton preventiveTask={preventiveTask} />{' '}
      <EditButton path={`${PREVENTIVE_TASK_PATH}/${preventiveTaskId}/edit`} />{' '}
      <DeletePreventiveTaskButton preventiveTaskId={preventiveTaskId} />
    </div>
  </ButtonToolbar>
);

PreventiveTaskToolbar.propTypes = {
  preventiveTaskId: PropTypes.number.isRequired,
  preventiveTask: PropTypes.instanceOf(Object).isRequired,
};

export default PreventiveTaskToolbar;
